import React, { useState, useEffect, useRef } from 'react';

export function find_feature(feature_code, subscription_features) {
	for(let i = 0; i < subscription_features.length; i++) {
		if(subscription_features[i].code === feature_code) {
			return subscription_features[i];
		}
	}
	return null;
}

export function has_feature(feature, is_superadmin) {
	if(is_superadmin) {
		return true;
	}
	return ((feature !== null) && (feature !== undefined) && (feature.is_enabled === true));
}

export function sanitize_text_input(raw_value){
	const dangerous_patterns = [
		/--/g,            // SQL comment
		/;/g,             // Statement separator
		/\/\*/g,          // Start of block comment
		/\*\//g,          // End of block comment
		/@@/g,            // SQL globals
		/@/g,             // SQL variables
		/\bunion\b/gi,
		/\bselect\b/gi,
		/\binsert\b/gi,
		/\bupdate\b/gi,
		/\bdelete\b/gi,
		/\bdrop\b/gi,
		/\btruncate\b/gi,
		/\bexec\b/gi,
		/\bcast\b/gi,
		/\bconvert\b/gi
	];

	let value = raw_value;
	if(typeof value !== "string"){
		return "";
	}

	// Remove NULL bytes or control chars
	value = value.replace(/[\0\x08\x09\x1a\n\r"'\\\%]/g, "");

	// Strip dangerous SQL tokens
	for(let i = 0; i < dangerous_patterns.length; i++){
		value = value.replace(dangerous_patterns[i], "");
	}

	// Trim whitespace
	value = value.trim();

	return value;
}

export function validate_required_text(value, min_length, max_length){
	if(!value){
		return false;
	}
	if(value.length < min_length){
		return false;
	}
	if(value.length > max_length){
		return false;
	}
	return true;
}

export function validate_dropdown(value, allowed_values){
	if(!value){
		return false;
	}
	if(!Array.isArray(allowed_values)){
		return false;
	}
	return allowed_values.includes(value);
}

const c_MobileWidth = 768;

export function is_mobile_view() {
  const [is_mobile, set_is_mobile] = useState(window.innerWidth < c_MobileWidth);

  useEffect(() => {
    const handleResize = () => {
      // 768px is the standard 'md' breakpoint in Bootstrap
      set_is_mobile(window.innerWidth < c_MobileWidth);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return is_mobile;
};
